/**
 * Page pays module
 * @module pays
 * @description Les fonctions appelées sur les pages http://www.tedav.com/ps-pays/voyage-pays
 *
 */
"use strict";
// Define the placeholder plugin
$.fn.placeholder = function () {
	if ('placeholder' in document.createElement('input')) {
		// This browser already supports placeholders.
		// Nothing to do here.
		return this;
	}
	this.each(function () {
		var input = $(this);
		input.on('focus', function () {
			if (input.val() == input.attr('placeholder')) {
				input.val('');
			}
		}).on('blur', function () {
			if (input.val() == '') {
				input.val(input.attr('placeholder'));
			}
		});

		// Show the placeholder on load
		input.trigger('blur');
	});
	return this;
};
// Gestion de la couleur du texte en fonction du bg
$.fn.brightness = function () {
	var bg_color, rgba, y;
	bg_color = this.css('background-color');
	if ((bg_color != null) && bg_color.length) {
		rgba = bg_color.match(/^rgb(?:a)?\(([0-9]{1,3}),\s([0-9]{1,3}),\s([0-9]{1,3})(?:,\s)?([0-9]{1,3})?\)$/);
		if (rgba != null) {
			if (rgba[4] === '0') {
				if (this.parent().length) return this.parent().brightness();
			} else {
				y = 2.99 * rgba[1] + 5.87 * rgba[2] + 1.14 * rgba[3];
				if (y >= 1275) {
					return 'light';
				} else {
					return 'dark';
				}
			}
		}
	} else {
		if (this.parent().length) return this.parent().brightness();
	}
};

/* Positionnement css selon le data-attribut xpos / ypos
 * @version 1.2
 * @author Gilles Maupoint
 */
$.fn.position = function (params) {
	var defaults = {
		breakpoint: 980
	};
	var settings = $.extend({}, defaults, params);

	var t = this.attr('data-ypos'),
		l = this.attr('data-xpos'),
		largeur = $(window).width();
	if (largeur < settings.breakpoint) {
		var ratio = largeur / settings.breakpoint;
		t = t * ratio;
		l = l * ratio;
	}
	this.css('left', l + 'px').css('top', t + 'px');
}

/** @function gis
 * @description Tooltip pour les maps
 * @version 1.2
 * @author Gilles Maupoint
 * @todo : hook => params
 */
$.fn.gis = function (params) {
	var defaults = {
		pin: $("[data-hook='pin']"),
		pos: $("[data-hook='pos']"),
		tooltip: $("[data-hook='tooltip']"),
		mapID: '#map',
		span: $("#map > span")
	};
	var settings = $.extend({}, defaults, params);

	settings.span.attr('data-hook', 'pin pos')
		.addClass('jtooltip-terdav')
		.next('div')
		.addClass('tooltip')
		.removeClass('terdav__map--lieu')
		.attr('data-hook', 'tooltip pos');

	// Init
	// On masque l'affichage des tooltip
	$("[data-hook='tooltip pos']").hide();

	// On positionne les pins et les tooltips selon leurs paramètres xpos et ypos

	$.each($(".tooltip, .jtooltip-terdav"), function () {
		var $this = $(this),
			b = $this.data('triangle');
		b ? $this.addClass(b) : '';
		$this.position();
	});

	/* data-triangle : par défaut les triangles sont placés en haut à gauche de la tooltip, si attribut présent et vaut bottom alors le triangle se trouvera en bas
	 */
	// Au survol du pin, on affiche la tooltip et on la masque lorsque l'on quitte

	var $span = $("#map > span");

	function over() {
		$('.tooltip').hide();
		var x = $(this).data('href');
		$('#pin-' + x).show();
	}

	function showHideHover(el) {
		//el.hover(over);
		el.click(over);
		$('#map').on('mouseleave', function () {
			$('.tooltip').delay(500).hide();
		});
		$('#map').find('img').on('click', function () {
			$('.tooltip').delay(500).hide();
		});
	}

	showHideHover($span);

}


var config = {};
var pays = {
	init: function init(config) {
		/** Variables
		 * @description Les variables communes à plusieurs fonctions
		 * @author Gilles Maupoint
		 * @version 1.2
		 * @example terdavCookie.settings.NomDeLaVariable
		 */
		var settings = {
			mapId: '#map',
			colorsHot: ['#fef2c4', '#fee7a0', '#fed07c', '#fdbf5e', '#feb259', '#fba75d', '#f99246', '#f9893e', '#f97c3e', '#fb7540', '#fa6c40'],
			colorsCold: ['#1678bf', '#1678bf', '#2f87c6', '#2f87c6', '#2f87c6', '#5fa8db', '#5fa8db', '#aed9f7', '#aed9f7', '#e0f0fb', '#e0f0fb'],
			colorsDay: ['#091359', '#091359', '#434878', '#434878', '#7e7d8f', '#7e7d8f', '#b6b1a4', '#b6b1a4', '#e6dcb7', '#e6dcb7', '#f7ebbf'],
			onglets: ['presentation', 'climat', 'infos', 'voyages', 'guides', 'coutumes'],
			current: ''
		};


		/**
		 * @description Gestion du current du menu
		 * @param {string} nomPays Nom du pays
		 * @param {string} [idNav = #navigation] Id de la balise `nav`
		 * @param {string} [currentClass = current] Classe de la page courante
		 * module:pays~tools
		 * @author Gilles Maupoint
		 * @version 1.1
		 * @example
		 * var tools : function(params) {
		 *  var defaults = {
		 *   nomPays: '',
		 *   idNav : '#navigation',
		 *   currentClass : 'current'
		 *  };
		 *  var settings = $.extend({}, defaults, params);
		 *  var pos = jQuery.inArray(settings.page, settings.onglets ) + 1,
		 *  $li     = $(settings.idNav).find('li');
		 *  $li.eq(pos).addClass(settings.currentClass);
		 * }
		 */
		var tools = function (params) {
			var defaults = {
				nomPays: '',
				idNav: '#menuPays', //'#navigation',
				currentClass: 'current'
			};
			var settings = $.extend({}, defaults, params);
			var pos = jQuery.inArray(config.page, settings.onglets),
				$li = $(settings.idNav).find('li');

			$li.eq(pos).addClass(settings.currentClass);

			$('.lazy').lazyload();

		};

		/** @function toggleIntroText
		 * @description Gestion du current du menu
		 * @param {selector} [$b = $("[data-hook='showNext')] Bouton show/next
		 * @memberof Pages pays
		 * @author Gilles Maupoint
		 * @version 1.1
		 * @example
		 * toggleIntroText : function() {
		 *   var $b = $("[data-hook='showNext');
		 *   if($b.length) {
		 *     // on masque les paragraphes > n+2
		 *     var s = $b.parent().parent().find('p').not('.weight--semibold, .weight--semibold + p').hide();
		 *     $b.on('click', function(event) {
		 *       s.slideToggle('slow');
		 *       $b.text(function(i, text){
		 *         return text === "> Lire la suite" ? "> Masquer" : "> Lire la suite";
		 *       });
		 *     });
		 *   }
		 * }
		 */
		var toggleIntroText = function () {
			var $b = $("[data-hook='showNext']");
			if ($b.length) {
				// on masque les paragraphes > n+2
				/*var s = $b.parent().parent().find('p').not(':last').not(':first').hide();*/
				var s = $b.parent().parent().find('p');
				s.not(':last').not(':first').not(':nth-of-type(2)').addClass('is-hidden').hide();

				$b.on('click', function (event) {
					s.not(':last').not(':first').not(':nth-of-type(2)').slideToggle('slow');
					$b.text(function (i, text) {
						return text === "> Lire la suite" ? "> Masquer" : "> Lire la suite";
					});
				});
			}
		};
		/** @function carte
		 * @description Affichage des pins sur la carte
		 * @param {selector} [settings.mapId = #map] Id de la carte
		 * @requires gis()
		 * @memberof Pages pays
		 * @author Gilles Maupoint
		 * @version 1.1
		 * @example
		 * carte : function(settings) {
		 *   $(settings.mapId).exists() && !jQuery.browser.mobile && $(settings.mapId).gis();
		 * }
		 */
		var carte = function (settings) {
			require('common/helpers').elementExist(settings.mapId) && $(window).width() > 768 && $(settings.mapId).gis();

			$(settings.mapId).find('.jtooltip-terdav').hover(function () {
				var _self = $(this),
					img = _self.next().find('.lazymap'),
					dataSrc = img.attr('data-original');
				img.attr('src', dataSrc);
			});

		};

		/** @function minMaxTemp
		 * @description Renvoie un array comportant la valeur min et max
		 * @param {integer} data valeur de la data
		 * @memberof Pages pays
		 * @author Gilles Maupoint
		 *
		 */
		var minMaxTemp = function (selector, data) {
			var min = null,
				max = null;
			$(selector).each(function () {
				var id = parseInt($(this).data(data), 10);
				if ((min === null) || (id < min)) {
					min = id;
				}
				if ((max === null) || (id > max)) {
					max = id;
				}
			});
			return {
				min: min,
				max: max
			};
		};

		/** @function clock
		 * @description Affiche une horloge avec l'heure d'un fuseau donnée (couplé à moment.js)
		 */
		var clock = function (params) {
			var defaults = {
				horloge: $('#clock'),
				formatTime: ['HH', 'mm', 'ss'],
				idTime: ['#hours', '#min', '#sec'],
			};
			var settings = $.extend({}, defaults, params);
			//require(['moment'], function(moment) {
			//var moment = require('moment');
			if (typeof moment == 'undefined')
				return false;

			if (settings.horloge.length) {
				setInterval(function () {
					var seconds = moment().tz(config.timezone).format(settings.formatTime[2]);
					$(settings.idTime[2]).html(seconds);
				}, 1000);

				setInterval(function () {
					var minutes = moment().tz(config.timezone).format(settings.formatTime[1]);
					$(settings.idTime[1]).html(minutes);
				}, 1000);

				setInterval(function () {
					var hours = moment().tz(config.timezone).format(settings.formatTime[0]);
					$(settings.idTime[0]).html(hours);
				}, 1000);
			}
			//});
		};

		/** @function carouselInit
		 * @description Activation du carousel
		 * @param {selector} [carousel = $('#carousel')] selecteur jQuery du carousel
		 */
		var carouselInit = function (params) {
			var defaults = {
				carousel: $('#carousel')
			};
			var settings = $.extend({}, defaults, params);
			var defaultSliderConfig = {
				mobileFirst: true,
				arrows: false
			};
			require("common/helpers").elementExist('#carousel') && settings.carousel.find('.js-slider').slick(defaultSliderConfig);
		};

		/** @function colorisationTemperature
		 * @description Couleur du bg des températures
		 * @memberof Pages pays
		 * @author Gilles Maupoint
		 * @version 1.1
		 */
		var colorisationTemperature = function (params) {
			var defaults = {
				type: 'temperature',
				e: $('#temperatures').find('p'),
				a: minMaxTemp('[data-temperature]', 'temperature'),
				coldCountry: $('#temperatures').is('.js-paysfroid') ? true : false
			};
			var config = $.extend({}, defaults, params);

			$.each(config.e, function (index, val) {
				var $this = $(this),
					t = parseInt($this.data(config.type)),
					percent = Math.round((((t - config.a.min) / (config.a.max - config.a.min)) * 10).toFixed(2));
				// Définition de la color-bg
				if (!config.coldCountry) {
					$this.css('background-color', settings.colorsHot[percent]);
				} else {
					$this.css('background-color', settings.colorsCold[percent]);
				}
				// Changement couleur texte si bg trop dark
				$this.brightness() == 'dark' ? $this.css('color', 'white') : '';
			});
		};
		/** @function colorisationSoleil
		 * @description Couleur du bg des temps d'ensoleillement
		 * @memberof Pages pays
		 * @author Gilles Maupoint
		 * @version 1.1
		 */
		var colorisationSoleil = function (params) {
			var defaults = {
				type: ensoleillement,
				e: $('#ensoleillement').find('li p')
			};
			var config = $.extend({}, defaults, params);

			// OK
			$.each($('[data-jour]'), function () {
				var duree = $(this).text().split('h'),
					dureeMinutes = parseInt(duree[0]) * 60 + parseInt(duree[1]);
				$(this).data('jour', dureeMinutes);
			});

			var a = minMaxTemp('[data-jour]', 'jour');
			$.each($('[data-jour]'), function () {
				var $this = $(this),
					t = parseInt($this.data('jour')),
					percent = Math.round((((t - a.min) / (a.max - a.min)) * 10).toFixed(2));
				$this.css('background-color', settings.colorsDay[percent]);
				$this.brightness() == 'dark' ? $this.css('color', 'white') : '';
			});
		};
		/** @function colorisationPluie
		 * @description Largeur de la bordure des précipitations
		 * @memberof Pages pays
		 * @author Gilles Maupoint
		 * @version 1.1
		 */
		var colorisationPluie = function (params) {
			var defaults = {
				a: minMaxTemp('[data-precipitation]', 'precipitation'),
				e: $('#precipitations').find('p')
			};
			var settings = $.extend({}, defaults, params);

			$.each(settings.e, function (index, val) {
				var t = parseInt($(this).data('precipitation')),
					percent = Math.round((((t - settings.a.min) / (settings.a.max - settings.a.min)) * 10).toFixed(2));
				percent == 0 ? percent = 1 : ""; // pour que les précipations aient au mois une bordure d'1 px
				$(this).css('border-width', percent + 'px').css('line-height', 50 - percent * 2 + 'px');
			});
		};
		/** @function climat
		 * @description Gestion de le background-color des mois sur les pages climats
		 * @requires colorisationTemperature()
		 * @requires colorisationSoleil()
		 * @requires colorisationPluie()
		 * @memberof Pages pays
		 * @author Gilles Maupoint
		 * @version 1.1
		 */
		var climat = function () {
			if (require('common/helpers').elementExist('#temperatures'))
				colorisationTemperature();

			if (require('common/helpers').elementExist('#ensoleillement'))
				colorisationSoleil();

			if (require('common/helpers').elementExist('#precipitations'))
				colorisationPluie();
		};
		/** @function devise
		 * @description Gestion du widget de conversion de devise
		 * @requires placeholder()
		 * @memberof Pages pays
		 * @author Gilles Maupoint
		 * @version 1.1
		 */
		var devise = function (params) {
			var defaults = {
				url: 'https://openexchangerates.org/api/latest.json?app_id=399f7a555c064dc48409500548b67fa5',
				idEuro: '#euro',
				idDevise: '#other',
				errorClass: 'error'
			};
			var settings = $.extend({}, defaults, params);
			// requête exchange
			$.ajax({
				type: 'GET',
				url: settings.url,
				dataType: "jsonp",
				success: function (data) {
					$.each(data, function (key, val) {
						var exchange = data.rates[config.monnaie],
							rate = '',
							rateLocal = data.rates['EUR'];
						if (config.deviseLocale != undefined)
							rateLocal = data.rates['CAD'];
						isNaN(exchange) ? rate = settings.rateDefault : rate = exchange;
						$(settings.idEuro).on('keyup', function (event) {
							var v = ($(this).val() / rateLocal) * rate,
								$d = $(settings.idDevise);
							v = v.toFixed(2);
							$.isNumeric(v) ? $d.val(v).removeClass(settings.errorClass) : $(this).addClass(settings.errorClass);
						});

						$(settings.idDevise).on('keyup', function (event) {
							var v = ($(this).val() / rate) * rateLocal,
								$e = $(settings.idEuro);
							v = v.toFixed(2);
							$.isNumeric(v) ? $e.val(v).removeClass(settings.errorClass) : $(this).addClass(settings.errorClass);
						});
					});
				},
				error: function () {
					console.error('erreur');
				}
			});
			$(settings.idEuro, settings.idDevise).placeholder().on('click', function () {
				$(this).select();
			});
		};

		//const ITEM_MENU = $('#navigation').find('li');
		//
		const ITEM_MENU = $('#menuPays').find('li');

		var menuMobile = function () {

			// Close all panels
			ITEM_MENU.hide();

			// Accordion
			$('#subnavHc').on('click', function () {
				//var btn = $('.accordion-header');
				ITEM_MENU.is(':visible') ? ITEM_MENU.css('display', 'none') : ITEM_MENU.css('display', 'block');


				return false;
			});
		};

		// fonctions
		tools(settings);
		if ($(window).width() < 768) {
			menuMobile();
		}
		carouselInit();
		$(function () {
			$('#video-gallery, .video-guide').lightGallery();
		});


		// Prez générale
		if (config.page == settings.onglets[0]) {
			toggleIntroText(settings);
			carte(settings);
			//panel(settings);


		}

		// Climat
		// TO DO : factoriser $.each()
		config.page == settings.onglets[1] ? climat() : '';

		// Infos pratiques
		// TO DO
		if (config.page == settings.onglets[2]) {
			devise(settings);
			clock(settings);
		}

	}
};


$(function () {
	$('.lazy, [data-original]').lazyload();
	pays.init(config);
});